/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { signInPath, registrationPath } from 'constants/urls';
import s from './styles.module.scss';
import Icon from 'components/core/icon';
import HeaderShared from './layout/header';
import FooterShared from './layout/footer';

const Installation = ({ className = null }) => {
  const { t } = useTranslation();

  const language = getLanguage()?.toLowerCase();

  return (
    <div className={cx(s.sharedForm, className, s.sharedFormSignIn)}>
      <HeaderShared className={s.sharedFormHeader}>
        <Icon className={s.sharedFormLogo} icon={Icon.icons.logo} />
      </HeaderShared>
      <div className={s.sharedFormContent}>
        <Link to="#" className={s.sharedFormContentLink}>
          {t('quick_start_guide')}
        </Link>
        <Link to={signInPath} className={s.sharedFormContentLink}>
          {t('login')}
        </Link>
      </div>
      <FooterShared className={s.sharedFormFooterSignIn}>
        {t('dont_have_account')}
        <Link to={registrationPath} className={s.sharedFormFooterLink}>
          {t('create_profile')}
        </Link>
      </FooterShared>
      <div className={s.sharedFormMarkets}>
        <h4 className={s.sharedFormMarketsTitle}>{t('check_apps')}</h4>
        <div className={s.sharedFormMarketsLinks}>
          <AppStoreBadge language={language} />
          <GooglePlayBadge language={language} />
        </div>
      </div>
    </div>
  );
};

Installation.propTypes = {
  className: PropTypes.string,
};

export default Installation;
